<p-panel>
  <app-reactive-form-builder
    #formbuilder
    (formChanges)="formChanges($event[0], $event[1])"
    (goBack)="goBack()"
    (afterSend)="undefined"
    [form]="form.formFields"
    [serverUrl]="''"
    [dropdownLoadTrigger]="dropdownLoadTrigger"
    [dropdownsFinalized]="dropdownsFinalized"
    [id]="getModel().id ?? ''"
    [request]="getType() === formTypes.EDITION ? ventasApi.ventasPUT : ventasApi.ventasPOST"
    [getRequest]="ventasApi.ventasGET">
  </app-reactive-form-builder>
</p-panel>